export default __webpack_public_path__ + "860f824643c3d9986438d983fe72b7ce.png";